import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchDetailsOfPlan = (payload) => {
  return {
    type: actionTypes.FETCH_DETAILS_OF_PLAN,
    formData: payload,
  };
};
// bi started
export const editDetailsOfPlanStarted = () => {
  // //console.log(formData)
  return {
    type: actionTypes.FETCH_DETAILS_OF_PLAN_START,
  };
};

export const editDetailsOfPlanSuccess = (formData, succMsg, res) => {
  return {
    type: actionTypes.FETCH_DETAILS_OF_PLAN_SUCCESS,
    formData: formData,
    succMsg: "Proposal Updated Successfully",
    response: res,
  };
};

// export const fetchDetailsOfPlanSuccess = (payload, apiPath) => {
//   return async (dispatch) => {
//     dispatch(editDetailsOfPlanStarted());

//     axiosRequest
//       .put(apiPath, payload)
//       .then((res) => {
//         dispatch(fetchDetailsOfPlan(res?.sameAsBI));
//         return res;
//       })
//       .catch((err) => {
//         //console.log(err)
//       });
//   };
// };

export const fetchDetailsOfPlanSuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editDetailsOfPlanStarted());
    try {
      const res = await axiosRequest.put(apiPath, payload);
      dispatch(fetchDetailsOfPlan(res?.sameAsBI));
      return res; // Return the response
    } catch (err) {
      // Handle errors here if needed
      console.error("Error in fetchDetailsOfPlanSuccess:", err);
      throw err; // Re-throw the error to propagate it to the caller
    }
  };
};

export const editDetailsOfPlanFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_DETAILS_OF_PLAN_FAIL,
    error: errMsg,
  };
};
